import clarity from '@microsoft/clarity';

const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID || '';

export const initializeClarity = () => {
  try {
    clarity.init(CLARITY_PROJECT_ID);
    console.log('Microsoft Clarity initialized');
  } catch (error) {
    console.error('Clarity initialization error:', error);
  }
};

export const claritySetUserId = (userId: string) => {
  try {
    clarity.identify(userId);
  } catch (error) {
    console.error('Clarity setUserId error:', error);
  }
};

export const claritySetTag = (key: string, value: string | string[]) => {
  try {
    clarity.setTag(key, value);
  } catch (error) {
    console.error('Clarity setTag error:', error);
  }
};